export default function TaxOfficeHoursChange() {
    return (
        <div className="accordion-item">
        <h2 className="accordion-header">
            <button className="accordion-button caret-off collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTaxOfficeClosed">
                <div className="custom-button-layout">
                    
                    <i className="fa-solid fa-dollar-sign fa-2xl feature-icon af-icon"></i>
                    
                    
                    <b>Tax Collector Office Hours Changes&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                         <br/>March 2026 through June 2026&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</b>
                    
                    
                     
                     <span className="badge text-bg-dark">NOTICE</span>
                     
                </div>
            </button>
        </h2>
        <div id="collapseTaxOfficeClosed" className="accordion-collapse collapse" data-bs-parent="#latestNewsAccordion">
            <div className="accordion-body">
                <p>
                    Tax Collector office hours have been adjusted for the next several months:</p>
                    
                    <strong>March &amp; April</strong><br/>
                    <ul>
                        <li>Monday: 11:00 A.M. to 1:00 P.M.</li>
                        <li>Tuesday: 5:00 P.M. to 7:00 P.M.</li>
                        <li>Friday: 9:00 A.M. to 12:00 P.M.</li>
                    </ul>
                    
                    <strong>May &amp; June</strong><br/>
                    <ul>
                        <li>Friday Only: 9:00 A.M. to 12:00 P.M.</li>
                    </ul>
<p>
                    <strong>Tax Office Location</strong><br/>
                    <a href="https://maps.app.goo.gl/RjUcQgXYQvFVtETj8">
                    <i className="fa-solid fa-location-pin"></i>&nbsp;Morrisville Borough Hall<br/>35 Union Street  Morrisville, PA 19067
                  </a></p>

                  <p><strong>Contact Information</strong><br/>
                  Kathryn Schell, Tax Collector<br/>
                   <a href="mailto:katie0179@aol.com">
                    <i className="fa-solid fa-envelope"></i>
                    &nbsp;katie0179@aol.com
                  </a>
                  <br />
                  <a href="tel:9415254425">
                    <i className="fa-solid fa-phone"></i>&nbsp; 941-525-4425
                  </a>                  
                  </p>


                 
            </div>
        </div>
    </div>
    )
}